export default __webpack_public_path__ + "static/media/Mayur wagh.4ca587a9.jpeg";